/*
 * @Author: your name
 * @Date: 2020-10-19 10:18:51
 * @LastEditTime: 2022-11-22 17:03:16
 * @LastEditors: Lily lily.song@hrtps.com
 * @Description: In User Settings Edit
 * @FilePath: /Projects/tenant-product-admin/src/config/routes.ts
 */
import React from 'react';

const routes = (): IRoute[] => [
    {
        path: '/',
        component: () => import('layouts/BlankLayout'),
        routes: [
            {
                path: '/admin',
                component: () => import('layouts/UserLayout'),
                routes: [
                    {
                        path: '/admin/login',
                        component: () => import('pages/admin/login')
                    }
                ]
            },
            {
                path: '/',
                component: () => import('layouts/BasicLayout'),
                routes: [
                    {
                        path: '/tenant/list',
                        name: '租户管理',
                        component: () => import('pages/tenant/list')
                    },
                    {
                        path: '/tenant/detail/:tennatId?',
                        name: '租户详情',
                        showInMenu: false,
                        component: () => import('pages/tenant/detail')
                    },
                    {
                        path: '/product/list',
                        name: '产品管理',
                        component: () => import('pages/product/List/List')
                    },
                    {
                        path: '/application/list',
                        name: '应用管理',
                        component: () => import('pages/application/index')
                    },
                    {
                        path: '/service/list',
                        name: '服务管理',
                        component: () => import('pages/service/List/List')
                    },
                    {
                        path: '/timedTask/list',
                        name: '定时任务管理',
                        component: () => import('pages/timedTask/index')
                    },
                    {
                        path: '/databaseInit/list',
                        name: '数据库初始化管理',
                        component: () => import('pages/databaseInit/index')
                    },
                    {
                        path: '/product/tenant/list',
                        name: 'AI陪练', // 产品客户管理
                        component: () => import('pages/product/tenant/List')
                    },
                    {
                        path: '/service/detail/:serviceId',
                        showInMenu: false,
                        component: () => import('pages/service/Detail/Detail')
                    },
                    {
                        path: '/user/list',
                        name: '用户管理',
                        component: () => import('pages/user')
                    },
                    {
                        path: '/algorithm/manage',
                        name: '算法配置',
                        component: () => import('pages/algorithm')
                    },
                    {
                        path: '/tool',
                        name: '工具',
                        component: () => import('layouts/BlankLayout'),
                        routes: [
                            {
                                path: '/tool/tenant/db/update',
                                name: '租户DB更新',
                                component: () =>
                                    import('pages/tool/tenantDBUpdate')
                            }
                        ]
                    },
                    {
                        path: '/',
                        redirect: '/tenant/list',
                        showInMenu: false
                    },
                    {
                        component: () => import('pages/exception/notFound')
                    }
                ]
            }
        ]
    }
];

function addLazyComponent(routes: IRoute[]) {
    routes.forEach(route => {
        route.component = React.lazy(route.component);
        if (route.routes) {
            addLazyComponent(route.routes);
        }
    });
}

const getRoutes = () => {
    const routeList = routes();
    addLazyComponent(routeList);
    return routeList;
};

export default getRoutes;
